import { createTheme } from "@mui/material/styles"

const theme = createTheme({
  navHeight: 74,
  sectionPadding: "padding-top: 1.5em; padding-bottom: 1.5em;",
  fonts: {
    primary: "Garamond Premier Pro, sans-serif",
    secondary: "Gopher, sans-serif",
    tertiary: "Inter, sans-serif",
  },
  layout: {
    contentWidth: 1236,
  },
  palette: {
    primary: {
      // contrastText: "rgba(0, 0, 0, 0.87)",
      main: "#2E1A3C",
      light: "#1F1D2F",
      dark: "#1F1D2F",
    },
    secondary: {
      // contrastText: "rgba(0, 0, 0, 0.87)",
      main: "#F2F4E8",
      light: "#f7f5fb",
      dark: "#221E20",
    },
    tertiary: {
      main: "#1D0F28",
    },
    text: {
      primary: "#021500",
      secondary: "#F7F7F1",
      content: "#021500",
      tertiary: "#1A2933",
      disabled: "#10355A",
      hint: "#10355A",
      light: "#F1F3E7",
      secondLight: "#F9F5FC",
      tertiaryLight: "#E9EDD5",
      error: "#d32f2f",
    },
    alternate: {
      main: "rgb(247, 249, 250)",
      dark: "#e8eaf6",
    },
  },
  typography: {
    fontFamily: `"Garamond Premier Pro", "Open Sans", "Arial", sans-serif`,
  },
})

export default theme
